const normalizeNamePart = (value) => {
  if (value == null) return ''
  return String(value).trim()
}

export const formatUserFullName = (user = {}) => {
  const firstName = normalizeNamePart(user.first_name)
  const middleName = normalizeNamePart(user.middle_name)
  const lastName = normalizeNamePart(user.last_name)

  return [firstName, middleName, lastName].filter(Boolean).join(' ')
}

export const formatUserDisplayName = (user = {}) => {
  const fullName = formatUserFullName(user)
  const email = normalizeNamePart(user.email)

  if (!email) return fullName
  if (!fullName) return `(${email})`

  return `${fullName} (${email})`
}
